import { Autocomplete, Grid, Typography } from "@mui/material";
import { TextField } from "@mui/material";
import {
  CmpButton,
  CmpButtonKWithIcon,
} from "../../../Component/Common/ToolBox/ToolBox";

import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";

import { TimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useEffect, useState } from "react";
import {
  fSave,
  fValidateInvExistence,
  fValidationHead_Client,
  G1_LoadVersion,
  G1_PendingPO_Attributes,
  G1_POPending_DELETE,
  G1_POPending_POST_REVERSE,
} from "../WmsDashboardAction";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
  CmpDatePickerField001V1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
import GCLoadingBay from "./GCLoadingBay";
import {
  G1_PendingPO_ValidateInvExistence_GETROW,
  getSalesDocForSalesReturn_GETROW,
} from "../../../Server/ApiV2";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";
const GCDetail = ({
  vRdxWmsHead,
  reset = () => {},
  setHead = () => {},
  init = {},
  sDrawerTitle = {},
}) => {
  const [sModal, setModal] = useState(false);
  const [sReceiveModal, setReceiveModal] = useState(false);
  const [sAttribute, setAttribute] = useState({
    UnBayLoading: [],
    Receiver: [],
    Version: [],
    Type: [],
    Party: [],
    Location: [],
    DefVersion: 0,
  });

  const handleTimeDifference = (startTime, finishTime) => {
    // if (startTime && finishTime) {
    //   // Convert "HH:mm:ss" strings back to dayjs objects
    //   const start = dayjs(startTime, "HH:mm:ss");
    //   const finish = dayjs(finishTime, "HH:mm:ss");

    //   const diffInMinutes = finish.diff(start, "minute"); // Calculate the difference in minutes
    //   return diffInMinutes;
    // } else {
    //   return 0; // Reset if one of the values is missing
    // }
    if (startTime && finishTime) {
      // Convert "HH:mm:ss" strings back to dayjs objects
      const start = dayjs(startTime, "HH:mm:ss");
      const finish = dayjs(finishTime, "HH:mm:ss");

      // Calculate the difference in minutes
      const diffInMinutes = finish.diff(start, "minute");

      // Convert minutes to hours (and format to 2 decimal places)
      const diffInHours = (diffInMinutes / 60).toFixed(2);

      return diffInHours; // Returning hours as a string formatted to 2 decimal places
    } else {
      return "0.00"; // Return 0 if one of the values is missing
    }
  };

  const onLoad = async () => {
    let resp = await G1_PendingPO_Attributes(
      setAttribute,
      vRdxWmsHead?.VoucherNo,
      vRdxWmsHead?.VoucherTypeCode,
      sDrawerTitle?.trntype
    );
    if (resp.Version.length > 0) {
      setHead((obj) => ({
        ...obj,
        Version: resp.DefVersion || resp?.Version[0].Uid,
      }));
    }
    if (resp.Type.length > 0) {
      setHead((obj) => ({
        ...obj,
        Type: resp.DefaultType || resp?.Type[0].UID,
      }));
    }
    await G1_LoadVersion(
      setHead,
      vRdxWmsHead.VoucherTypeCode,
      vRdxWmsHead.VoucherNo,
      resp?.DefVersion || resp?.Version[0].Uid,
      handleTimeDifference
    );
  };
  const fRefDocType = async () => {
    let obj = {
      v_Scan: vRdxWmsHead.A_RefDocNo || "",
    };
    const resp = await getSalesDocForSalesReturn_GETROW(obj);
    if (resp?.status === 200) {
      console.log(resp.data.ResultSet[0]);
      setHead((obj) => ({
        ...obj,
        A_RefTyp: resp.data.ResultSet[0].A_VocTyp,
        A_RefName: resp.data.ResultSet[0].A_VocTypName,
        A_RefDocNo: resp.data.ResultSet[0].A_VocNo,
        PartyCode: resp.data.ResultSet[0].Party,
        GRNNetAmt: resp.data.ResultSet[0].NetAmt,
        PoNetAmount: resp.data.ResultSet[0].NetAmt,
        NoOfLineItems: resp.data.ResultSet[0].LineItems,
        NoOfItems: resp.data.ResultSet[0].LineItems,
        InvNo: resp.data.ResultSet[0].A_VocNo,
        InvDate: resp.data.ResultSet[0].A_PostDt,
      }));
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={6} md={4}>
          <CmpSelectFieldV1
            xtabIndex={"1"}
            xLabelText="Type"
            xValue={vRdxWmsHead.Type}
            xOnChange={(e) => {
              setHead((obj) => ({
                ...obj,
                Type: e.target.value,
              }));
            }}
            xName={"Type"}
            xData={sAttribute?.Type}
            xValueMember={""}
            xDispalyMember={""}
            xError={false}
            xErrorMessage={""}
            xDisable={true}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid item xs={6} md={4}>
          <CmpTextFieldV1
            xLabelText="Voucher Type"
            xValue={vRdxWmsHead.VoucherTypeCode}
            xType={"text"} // text/number/password
            xName={"VoucherTypeCode"}
            xReadOnly={true}
            xOnChange={(e) => {
              setHead((obj) => ({
                ...obj,
                VoucherTypeCode: e.target.value,
              }));
            }}
            xError={false}
            xErrorMessage={""}
            // xOnKeyUp={fKeyLoadingReceipt}
          />
        </Grid>

        <Grid item xs={6} md={4}>
          <CmpTextFieldV1
            xLabelText="VocTypName"
            xValue={vRdxWmsHead.VoucherTypeName}
            xType={"text"} // text/number/password
            xName={"VoucherTypeName"}
            xReadOnly={true}
            xOnChange={(e) => {
              setHead((obj) => ({
                ...obj,
                VoucherTypeName: e.target.value,
              }));
            }}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>

        <Grid item xs={6} md={4}>
          <CmpTextFieldV1
            xLabelText="Voucher No"
            xValue={vRdxWmsHead.VoucherNo}
            xType={"text"} // text/number/password
            xName={"VoucherNo"}
            xReadOnly={true}
            xOnChange={(e) => {
              setHead((obj) => ({
                ...obj,
                VoucherNo: e.target.value,
              }));
            }}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>

        <Grid item xs={6} md={4}>
          <CmpDatePickerField001V1
            xLabelText="Ref.Date"
            xtabIndex={"4"}
            xValue={vRdxWmsHead.RefDate}
            xOnChange={(e) => {
              if (
                e?.$d == "Invalid Date" ||
                e?.$d == null ||
                e?.$d === undefined ||
                e?.$d === ""
              ) {
                setHead((obj) => ({
                  ...obj,
                  RefDate: "",
                }));
              } else {
                setHead((obj) => ({
                  ...obj,
                  RefDate: e?.$d,
                }));
              }
            }}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>

        <Grid item xs={6} md={4}>
          <CmpSelectFieldV1
            xtabIndex={"1"}
            xLabelText="Version"
            xValue={vRdxWmsHead.Version}
            xOnChange={async (e) => {
              setHead((obj) => ({
                ...obj,
                Version: e.target.value,
              }));
              await G1_LoadVersion(
                setHead,
                vRdxWmsHead.VoucherTypeCode,
                vRdxWmsHead.VoucherNo,
                e.target.value,
                handleTimeDifference
              );
            }}
            xName={"Version"}
            xData={sAttribute?.Version}
            xValueMember={""}
            xDispalyMember={""}
            xError={false}
            xErrorMessage={""}
            xDisable={sDrawerTitle.trntype != "P"}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <CmpTextFieldV1
            xLabelText="Party"
            xValue={vRdxWmsHead.PartyCode}
            xType={"text"} // text/number/password
            xName={"PartyCode"}
            xReadOnly={
              sDrawerTitle.trntype == "P" || sDrawerTitle.trntype == "T"
            }
            xOnChange={(e) => {
              setHead((obj) => ({
                ...obj,
                PartyCode: e.target.value,
              }));
            }}
            xError={false}
            xErrorMessage={""}
            // xOnKeyUp={fKeyLoadingReceipt}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <Autocomplete
            freeSolo
            id="free-solo-1-demo"
            disableClearable
            size="small"
            className={
              sDrawerTitle.trntype == "P" || sDrawerTitle.trntype == "T"
                ? "disable-color test "
                : "test "
            }
            disabled={
              sDrawerTitle.trntype == "P" || sDrawerTitle.trntype == "T"
            }
            options={sAttribute?.Party} // Use full objects
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.Name2
            } // Support free text input
            value={
              sAttribute?.Party?.find(
                (obj) => obj.AcCd === vRdxWmsHead.PartyCode
              ) || null
            }
            onChange={(event, newValue) => {
              if (typeof newValue === "string") {
                setHead((obj) => ({
                  ...obj,
                  PartyCode: newValue.AcCd,
                  PartyName: newValue.Name2,
                }));
              } else if (newValue) {
                setHead((obj) => ({
                  ...obj,
                  PartyCode: newValue.AcCd,
                  PartyName: newValue.Name2,
                }));
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Party Name"
                slotProps={{
                  input: {
                    ...params.InputProps,
                    type: "search",
                  },
                }}
              />
            )}
          />
          {/* <CmpSelectFieldV1
            xtabIndex={"1"}
            xLabelText="PartyName"
            xValue={vRdxWmsHead.PartyCode}
            xOnChange={(e) => {
              setHead((obj) => ({
                ...obj,
                PartyCode: e.target.value,
              }));
            }}
            xName={"PartyCode"}
            xData={sAttribute?.Party}
            xValueMember={""}
            xDispalyMember={""}
            xError={false}
            xErrorMessage={""}
            xDisable={
              sDrawerTitle.trntype == "P" || sDrawerTitle.trntype == "T"
            }

            // xOnKeyUp={xKey}
          /> */}
        </Grid>

        <Grid item xs={6} md={4}>
          <CmpDatePickerField001V1
            xLabelText="Exp.Date"
            xtabIndex={"4"}
            xValue={vRdxWmsHead.ExpiryDate}
            xOnChange={(e) => {
              if (
                e?.$d == "Invalid Date" ||
                e?.$d == null ||
                e?.$d === undefined ||
                e?.$d === ""
              ) {
                setHead((obj) => ({
                  ...obj,
                  ExpiryDate: "",
                }));
              } else {
                setHead((obj) => ({
                  ...obj,
                  ExpiryDate: e?.$d,
                }));
              }
            }}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>

        <Grid item xs={6} md={4}>
          <CmpTextFieldV1
            xLabelText="PO Net Amount"
            xValue={vRdxWmsHead.PoNetAmount}
            xType={"text"} // text/number/password
            xName={"PoNetAmount"}
            xReadOnly={true}
            xOnChange={(e) => {
              setHead((obj) => ({
                ...obj,
                PoNetAmount: e.target.value,
              }));
            }}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>

        <Grid item xs={6} md={4}>
          <CmpTextFieldV1
            xLabelText="No of line items"
            xValue={vRdxWmsHead.NoOfLineItems}
            xType={"text"} // text/number/password
            xName={"NoOfLineItems"}
            xReadOnly={true}
            xOnChange={(e) => {
              setHead((obj) => ({
                ...obj,
                NoOfLineItems: e.target.value,
              }));
            }}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>

        <Grid item xs={6} md={4}>
          <CmpDatePickerField001V1
            xLabelText="GRN Date"
            xtabIndex={"4"}
            xValue={vRdxWmsHead.GRNDate}
            xOnChange={(e) => {
              if (
                e?.$d == "Invalid Date" ||
                e?.$d == null ||
                e?.$d === undefined ||
                e?.$d === ""
              ) {
                setHead((obj) => ({
                  ...obj,
                  GRNDate: "",
                }));
              } else {
                setHead((obj) => ({
                  ...obj,
                  GRNDate: e?.$d,
                }));
              }
            }}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>

        <Grid item xs={6} md={4}>
          <CmpTextFieldV1
            xLabelText="InvNo"
            xValue={vRdxWmsHead.InvNo}
            xType={"text"} // text/number/password
            xName={"InvNo"}
            xReadOnly={false}
            xOnChange={(e) => {
              setHead((obj) => ({
                ...obj,
                InvNo: e.target.value,
              }));
            }}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>

        <Grid item xs={6} md={4}>
          <CmpDatePickerField001V1
            xLabelText="InvDate"
            xtabIndex={"4"}
            xValue={vRdxWmsHead.InvDate}
            xOnChange={(e) => {
              if (
                e?.$d == "Invalid Date" ||
                e?.$d == null ||
                e?.$d === undefined ||
                e?.$d === ""
              ) {
                setHead((obj) => ({
                  ...obj,
                  InvDate: "",
                }));
              } else {
                setHead((obj) => ({
                  ...obj,
                  InvDate: e?.$d,
                }));
              }
            }}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>

        <Grid item xs={10} md={5}>
          <Autocomplete
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            size="small"
            options={sAttribute?.Receiver} // Use full objects
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.Name1
            } // Support free text input
            value={
              sAttribute?.Receiver?.find(
                (obj) => obj.Uid === vRdxWmsHead.AllocateReceiver
              ) || null
            }
            onChange={(event, newValue) => {
              if (typeof newValue === "string") {
                setHead((obj) => ({
                  ...obj,
                  AllocateReceiver: newValue.Uid,
                  AllocateReceiverName: newValue.Name1,
                }));
              } else if (newValue) {
                setHead((obj) => ({
                  ...obj,
                  AllocateReceiver: newValue.Uid,
                  AllocateReceiverName: newValue.Name1,
                }));
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="AllocateReceiver"
                slotProps={{
                  input: {
                    ...params.InputProps,
                    type: "search",
                  },
                }}
              />
            )}
          />
          {/* <CmpSelectFieldV1
            xtabIndex={"1"}
            xLabelText="AllocateReceiver"
            xValue={vRdxWmsHead.AllocateReceiver}
            xOnChange={(e) => {
              let { Uid, Name1 } = sAttribute?.Receiver.find(
                (obj) => obj.Uid == e.target.value
              );
              setHead((obj) => ({
                ...obj,
                AllocateReceiver: e.target.value,
                AllocateReceiverName: Name1,
              }));
            }}
            xName={"AllocateReceiver"}
            xData={sAttribute?.Receiver}
            xValueMember={""}
            xDispalyMember={""}
            xError={false}
            xErrorMessage={""}
            xDisable={false}
            // xOnKeyUp={xKey}
          /> */}
        </Grid>
        <Grid item xs={2} md={1}>
          <CmpButtonKWithIcon
            xOnClick={() => {
              setReceiveModal(true);
            }}
            xDisabled={vRdxWmsHead.AllocateReceiver == ""}
            xIcon={<MoreHorizIcon fontSize="medium" />}
          />
        </Grid>

        <Grid item xs={6} md={4}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              label="ExpStartTime"
              value={
                vRdxWmsHead.ExpStartTime
                  ? dayjs(vRdxWmsHead.ExpStartTime, "HH:mm:ss")
                  : null
              }
              onChange={(newValue) => {
                setHead((obj) => ({
                  ...obj,
                  ExpStartTime: newValue ? newValue.format("HH:mm:ss") : "",

                  TotalTimeinMin: handleTimeDifference(
                    newValue ? newValue.format("HH:mm:ss") : 0,
                    vRdxWmsHead.ExpFinishTime
                  ),
                }));
              }}
              ampm={true} // 24-hour format
              views={["hours", "minutes", "seconds"]} // Include seconds
              format="HH:mm:ss" // Display format
              renderInput={(params) => (
                <TextField {...params} size="small" fullWidth />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={6} md={2}>
          <CmpTextFieldV1
            xLabelText="seconds"
            xValue={dayjs(vRdxWmsHead.ExpStartTime, "HH:mm:ss").format("ss")}
            xType={"text"} // text/number/password
            xName={"seconds"}
            xReadOnly={false}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>

        <Grid item xs={10} md={5}>
          <Autocomplete
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            size="small"
            options={sAttribute?.UnBayLoading} // Use full objects
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.Name1
            } // Support free text input
            value={
              sAttribute?.UnBayLoading?.find(
                (obj) => String(obj?.UId) === String(vRdxWmsHead?.UnloadingBay)
              ) || null
            }
            onChange={(event, newValue) => {
              if (typeof newValue === "string") {
                setHead((obj) => ({
                  ...obj,
                  UnloadingBay: newValue.UId,
                  UnloadingBayName: newValue.Name1,
                }));
              } else if (newValue) {
                setHead((obj) => ({
                  ...obj,
                  UnloadingBay: newValue.UId,
                  UnloadingBayName: newValue.Name1,
                }));
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="UnloadingBay"
                slotProps={{
                  input: {
                    ...params.InputProps,
                    type: "search",
                  },
                }}
              />
            )}
          />
          {/* <CmpSelectFieldV1
            xtabIndex={"1"}
            xLabelText="UnloadingBay"
            xValue={vRdxWmsHead.UnloadingBay}
            xOnChange={(e) => {
              let { UId, Name1 } = sAttribute?.UnBayLoading.find(
                (obj) => obj.UId == e.target.value
              );

              setHead((obj) => ({
                ...obj,
                UnloadingBay: e.target.value,
                UnloadingBayName: Name1,
              }));
            }}
            xName={"UnloadingBay"}
            xData={sAttribute?.UnBayLoading}
            xValueMember={""}
            xDispalyMember={""}
            xError={false}
            xErrorMessage={""}
            xDisable={false}
            // xOnKeyUp={xKey}
          /> */}
        </Grid>
        <Grid item xs={2} md={1}>
          <CmpButtonKWithIcon
            xOnClick={() => {
              setModal(true);
            }}
            xDisabled={vRdxWmsHead.UnloadingBay == ""}
            xIcon={<MoreHorizIcon fontSize="medium" />}
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              label="ExpFinishTime"
              value={
                vRdxWmsHead.ExpFinishTime
                  ? dayjs(vRdxWmsHead.ExpFinishTime, "HH:mm:ss")
                  : null
              }
              onChange={(newValue) => {
                setHead((obj) => ({
                  ...obj,
                  ExpFinishTime: newValue ? newValue.format("HH:mm:ss") : 0,
                  TotalTimeinMin: handleTimeDifference(
                    vRdxWmsHead.ExpStartTime,
                    newValue ? newValue.format("HH:mm:ss") : 0
                  ),
                }));
              }}
              ampm={true} // 24-hour format
              views={["hours", "minutes", "seconds"]} // Include seconds
              format="HH:mm:ss" // Display format
              renderInput={(params) => (
                <TextField {...params} size="small" fullWidth />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={6} md={2}>
          <CmpTextFieldV1
            xLabelText="seconds"
            xValue={dayjs(vRdxWmsHead.ExpFinishTime, "HH:mm:ss").format("ss")}
            xType={"text"} // text/number/password
            xName={"seconds"}
            xReadOnly={false}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <CmpTextFieldV1
            xLabelText="GRNNetAmt"
            xValue={vRdxWmsHead.GRNNetAmt}
            xType={"number"} // text/number/password
            xName={"GRNNetAmt"}
            xReadOnly={false}
            xOnChange={(e) => {
              setHead((obj) => ({
                ...obj,
                GRNNetAmt: e.target.value,
              }));
              if (sDrawerTitle.trntype == "R") {
                setHead((obj) => ({
                  ...obj,
                  PoNetAmount: e.target.value,
                }));
              }
            }}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>

        <Grid item xs={6} md={2}>
          <CmpTextFieldV1
            xLabelText="NoOfItems"
            xValue={vRdxWmsHead.NoOfItems}
            xType={"number"} // text/number/password
            xName={"NoOfItems"}
            xReadOnly={false}
            xOnChange={(e) => {
              setHead((obj) => ({
                ...obj,
                NoOfItems: e.target.value,
              }));
              if (sDrawerTitle.trntype == "R") {
                setHead((obj) => ({
                  ...obj,
                  NoOfLineItems: e.target.value,
                }));
              }
            }}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>

        <Grid item xs={6} md={6}>
          <CmpTextFieldV1
            xLabelText="TotalTimeinMin"
            // xValue={vRdxWmsHead.TotalTimeinMin}
            xValue={vRdxWmsHead.TotalTimeinMin || 0}
            xType={"text"} // text/number/password
            xName={"TotalTimeinMin"}
            xReadOnly={true}
            xOnChange={(e) => {
              setHead((obj) => ({
                ...obj,
                TotalTimeinMin: e.target.value,
              }));
            }}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>
        <Grid item xs={6} md={12}>
          <CmpSelectFieldV1
            xtabIndex={"1"}
            xLabelText="Location"
            xValue={vRdxWmsHead.Location}
            xOnChange={(e) => {
              setHead((obj) => ({
                ...obj,
                Location: e.target.value,
              }));
            }}
            xName={"Location"}
            xData={sAttribute.Location}
            xValueMember={""}
            xDispalyMember={""}
            xError={false}
            xErrorMessage={""}
            xDisable={false}
            // xOnKeyUp={xKey}
          />
        </Grid>
        {vRdxWmsHead.Type == "SALES_RETURN" && (
          <Grid item xs={12} sm={12} md={12} container spacing={0.9}>
            <Grid item xs={6} sm={6} md={2}>
              <CmpTextFieldV1
                xLabelText="Ref.Typ"
                xSize="small"
                xValue={vRdxWmsHead.A_RefTyp}
                xType={"text"} // text/number/password
                xName={"A_RefDocCd"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <CmpTextFieldV1
                xLabelText="Ref.Name"
                xSize="small"
                xValue={vRdxWmsHead.A_RefName}
                xType={"text"} // text/number/password
                xName={"A_RefDocName"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <GCToggleSearchV1
                xLabelText="RefDocNo"
                xtabIndex={"101"}
                xName={"A_RefDocNo"}
                xType={"text"}
                xValue={vRdxWmsHead?.A_RefDocNo}
                xReadOnly={false}
                xOnChange={(e) => {
                  setHead((obj) => ({
                    ...obj,
                    A_RefDocNo: e.target.value,
                    A_RefTyp: "",
                    A_RefName: "",
                  }));
                }}
                xOnKeyUp={fRefDocType}
                xonClickbtn={fRefDocType}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
      <Grid
        container
        spacing={0.5}
        className="my-2"
        sx={{ alignItems: "center", justifyContent: "center" }}
      >
        <Grid item xs={4} md={2} className="text-center">
          <CmpButton
            xbtnName="Save"
            xOnClick={async (e) => {
              let validation = fValidationHead_Client(vRdxWmsHead);

              if (!validation) return;

              if (sDrawerTitle?.trntype === "P") {
                await fValidateInvExistence(vRdxWmsHead, sDrawerTitle, setHead);
              } else {
                await fSave(vRdxWmsHead, sDrawerTitle, setHead);
              }

              await G1_LoadVersion(
                setHead,
                vRdxWmsHead.VoucherTypeCode,
                vRdxWmsHead.VoucherNo,
                vRdxWmsHead.Version,
                handleTimeDifference
              );
            }}
            xVariant="contained"
            //   xDisabled={!vRdxWmsHead.btnSave}
            xSize="small"
            xId={"IdSave"}
            xSendIcon={<SaveRoundedIcon />}
          />
        </Grid>

        <Grid item xs={4} md={2} className="text-center">
          <CmpButton
            xbtnName="Delete"
            xOnClick={async (e) => {
              await G1_POPending_DELETE(vRdxWmsHead);
              await G1_LoadVersion(
                setHead,
                vRdxWmsHead.VoucherTypeCode,
                vRdxWmsHead.VoucherNo,
                vRdxWmsHead.Version,
                handleTimeDifference
              );
            }}
            xVariant="contained"
            xDisabled={!vRdxWmsHead.btnDelete}
            xSize="small"
            xId="IdDelete"
            xSendIcon={<DeleteRoundedIcon />}
          />
        </Grid>
        <Grid item xs={4} md={2} className="text-center">
          <CmpButton
            xbtnName="Post"
            xOnClick={async (e) => {
              await G1_POPending_POST_REVERSE("POST", vRdxWmsHead);
              await G1_LoadVersion(
                setHead,
                vRdxWmsHead.VoucherTypeCode,
                vRdxWmsHead.VoucherNo,
                vRdxWmsHead.Version,
                handleTimeDifference
              );
            }}
            xVariant="contained"
            xDisabled={sAttribute?.DefVersion <= 0 || !vRdxWmsHead.btnPost}
            xSize="small"
            xId="IdDelete"
            xSendIcon={<DeleteRoundedIcon />}
          />
        </Grid>
        <Grid item xs={6} md={2} className="text-center">
          <CmpButton
            xbtnName="Reverse"
            xOnClick={async (e) => {
              await G1_POPending_POST_REVERSE("REVERSE", vRdxWmsHead);
              await G1_LoadVersion(
                setHead,
                vRdxWmsHead.VoucherTypeCode,
                vRdxWmsHead.VoucherNo,
                vRdxWmsHead.Version,
                handleTimeDifference
              );
            }}
            xVariant="contained"
            xDisabled={sAttribute?.DefVersion <= 0 || !vRdxWmsHead.btnReverse}
            xSize="small"
            xId="IdDelete"
            xSendIcon={<DeleteRoundedIcon />}
          />
        </Grid>
        <Grid item xs={6} md={2} className="text-center">
          <CmpButton
            xbtnName="Back"
            xOnClick={reset}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
            xId="IdDelete"
            xSendIcon={<ArrowBackIcon />}
          />
        </Grid>
      </Grid>
      <GCLoadingBay
        xOpen={sModal}
        fCloseLoadPoModal={() => {
          setModal(false);
        }}
        xTitle={"Loading Bay Detail"}
        Label={"Loading Bay"}
        xLabelValue={vRdxWmsHead.UnloadingBayName}
        v_user={""}
        v_Date={vRdxWmsHead.GRNDate}
        v_LDBay={vRdxWmsHead.UnloadingBay}
        column={[
          {
            field: "id",
            headerName: "ID",
            flex: 0.5,
            headerAlign: "center",
            align: "center",
            hide: false,
          },

          {
            field: "PONumber",
            headerName: "PONumber",
            flex: 1,
            headerAlign: "center",
            align: "left",
            hide: false,
          },
          {
            field: "StartTime",
            headerName: "StartTime",
            flex: 1,
            headerAlign: "center",
            align: "left",
            valueFormatter: ({ value }) =>
              moment(value).format("HH:mm") == "Invalid date"
                ? ""
                : moment(value).format("HH:mm"),
            hide: false,
          },
          {
            field: "FinishTime",
            headerName: "FinishTime",
            flex: 1,
            headerAlign: "center",
            align: "left",
            valueFormatter: ({ value }) =>
              moment(value).format("HH:mm") == "Invalid date"
                ? ""
                : moment(value).format("HH:mm"),
            hide: false,
          },
          {
            field: "TotalTime",
            headerName: "TotalTime",
            flex: 1,
            headerAlign: "center",
            align: "left",
            valueFormatter: ({ value }) =>
              moment(value).format("HH:mm") == "Invalid date"
                ? ""
                : moment(value).format("HH:mm"),
            hide: false,
          },
          // {
          //   field: "PDTUser",
          //   headerName: "PDTUser",
          //   flex: 1,
          //   headerAlign: "center",
          //   align: "left",
          //   hide: false,
          // },
          {
            field: "LoadingBay",
            headerName: "LoadingBay",
            flex: 1,
            headerAlign: "center",
            align: "left",
            hide: false,
          },
          {
            field: "ItemCount",
            headerName: "ItemCount",
            flex: 1,
            headerAlign: "center",
            align: "left",
            hide: false,
          },
          {
            field: "POAmount",
            headerName: "POAmount",
            flex: 1,
            headerAlign: "center",
            align: "left",
            hide: false,
          },
        ]}
      />
      <GCLoadingBay
        xOpen={sReceiveModal}
        fCloseLoadPoModal={() => {
          setReceiveModal(false);
        }}
        xTitle={"Receiver Detail"}
        v_user={vRdxWmsHead.AllocateReceiver}
        v_Date={vRdxWmsHead.GRNDate}
        Label={"PDT USer"}
        xLabelValue={vRdxWmsHead.AllocateReceiverName}
        v_LDBay={""}
        column={[
          {
            field: "id",
            headerName: "ID",
            flex: 0.5,
            headerAlign: "center",
            align: "center",
            hide: false,
          },

          {
            field: "PONumber",
            headerName: "PONumber",
            flex: 1,
            headerAlign: "center",
            align: "left",
            hide: false,
          },
          {
            field: "StartTime",
            headerName: "StartTime",
            flex: 1,
            headerAlign: "center",
            align: "left",
            valueFormatter: ({ value }) =>
              moment(value).format("HH:mm") == "Invalid date"
                ? ""
                : moment(value).format("HH:mm"),
            hide: false,
          },
          {
            field: "FinishTime",
            headerName: "FinishTime",
            flex: 1,
            headerAlign: "center",
            align: "left",
            valueFormatter: ({ value }) =>
              moment(value).format("HH:mm") == "Invalid date"
                ? ""
                : moment(value).format("HH:mm"),
            hide: false,
          },
          {
            field: "TotalTime",
            headerName: "TotalTime",
            flex: 1,
            headerAlign: "center",
            align: "left",
            valueFormatter: ({ value }) =>
              moment(value).format("HH:mm") == "Invalid date"
                ? ""
                : moment(value).format("HH:mm"),
            hide: false,
          },
          {
            field: "PDTUser",
            headerName: "PDTUser",
            flex: 1,
            headerAlign: "center",
            align: "left",
            hide: false,
          },
          // {
          //   field: "LoadingBay",
          //   headerName: "LoadingBay",
          //   flex: 1,
          //   headerAlign: "center",
          //   align: "left",
          //   hide: false,
          // },
          {
            field: "ItemCount",
            headerName: "ItemCount",
            flex: 1,
            headerAlign: "center",
            align: "left",
            hide: false,
          },
          {
            field: "POAmount",
            headerName: "POAmount",
            flex: 1,
            headerAlign: "center",
            align: "left",
            hide: false,
          },
        ]}
      />
    </div>
  );
};
export default GCDetail;
